import { useMediaQuery } from "./useMediaQuery";

/** Returns true when viewport is below Tailwind's `md` breakpoint (768px). */
export function useIsMobile(): boolean {
  return !useMediaQuery("(min-width: 768px)");
}
